export default __webpack_public_path__ + "static/media/serve.575a711c.mp4";